import { render, staticRenderFns } from "./ShippingInsurancesTable.vue?vue&type=template&id=748eb886&scoped=true"
import script from "./ShippingInsurancesTable.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748eb886",
  null
  
)

export default component.exports